const handleEditor = (editor, updateLogs) => {
    const updateLogsInternal = (field, increment) => {
        updateLogs((prev) => ({
            ...prev,
            [field]: prev[field] + increment
        }));
    };

    editor.onDidChangeModelContent((e) => {
        e.changes.forEach(change => {
            if (change.forceMoveMarkers) {
                return;
            }
            
            const text = change.text;
            updateLogsInternal("charsTyped", text.length);

            if (change.rangeLength > 0 && text === "") {
                updateLogsInternal("backspaces", change.rangeLength);
            }
        });
    });

    editor.onDidFocusEditorText(() => {
        updateLogsInternal("focusChanges", 1);
    });

    editor.onDidBlurEditorText(() => {        
        updateLogsInternal("focusChanges", 1);
    });

    editor.onDidPaste(() => {
        updateLogsInternal("pasteEvents", 1);
    });

    editor.onDidChangeCursorPosition(() => {
        updateLogsInternal("cursorMoves", 1);
    });

    editor.onMouseDown((_) => {
        updateLogsInternal("mouseClicks", 1);
    });

    editor.onKeyDown((e) => {
        const key = e.browserEvent.key;
        const metaKey = e.browserEvent.metaKey;
        const ctrlKey = e.browserEvent.ctrlKey;
        const altKey = e.browserEvent.altKey;
        
        const hasModifier = metaKey || ctrlKey || altKey;

        if (!hasModifier && key.length === 1 && key.match(/[\S ]/)) {
            console.log(e);
            updateLogsInternal("keystrokes", 1);
        }
    });

};

export default handleEditor;